const CustomPropertyNames = Object.freeze({
  // Make sure key names does not have JavaScript forbidden names.
  BackgroundCardPushButton: '--webchat__background--card-push-button',
  BackgroundBubble: '--webchat__background--bubble',
  BackgroundBubbleUser: '--webchat__background--bubble-user',
  BackgroundCodeBlock: '--webchat__background--code-block',
  BackgroundImageSpinnerAnimation: '--webchat__background-image--spinner-animation',
  BackgroundImageTypingAnimation: '--webchat__background-image--typing-animation',
  BackgroundToastError: '--webchat__background--toast-error',
  BackgroundToastInfo: '--webchat__background--toast-info',
  BackgroundToastSuccess: '--webchat__background--toast-success',
  BackgroundToastWarn: '--webchat__background--toast-warn',
  BackgroundTranscriptOverlayButton: '--webchat__background--transcript-overlay-button',
  BackgroundTranscriptOverlayButtonDisabled: '--webchat__background--transcript-overlay-button-disabled',
  BackgroundTranscriptOverlayButtonFocus: '--webchat__background--transcript-overlay-button-focus',
  BackgroundTranscriptOverlayButtonHover: '--webchat__background--transcript-overlay-button-hover',
  BackgroundTranscriptTerminator: '--webchat__background--transcript-terminator',
  BorderAnimationColor1: '--webchat__border-animation--color-1',
  BorderAnimationColor2: '--webchat__border-animation--color-2',
  BorderAnimationColor3: '--webchat__border-animation--color-3',
  BorderColorBubble: '--webchat__border-color--bubble',
  BorderColorBubbleUser: '--webchat__border-color--bubble-user',
  BorderRadiusAvatar: '--webchat__border-radius--avatar',
  BorderRadiusBubble: '--webchat__border-radius--bubble',
  BorderRadiusBubbleUser: '--webchat__border-radius--bubble-user',
  BorderStyleBubble: '--webchat__border-style--bubble',
  BorderStyleBubbleUser: '--webchat__border-style--bubble-user',
  BorderStyleTranscriptActivityVisualKeyboardIndicator:
    '--webchat__border-style--transcript-activity-visual-keyboard-indicator',
  BorderStyleTranscriptVisualKeyboardIndicator: '--webchat__border-style--transcript-visual-keyboard-indicator',
  BorderWidthBubble: '--webchat__border-width--bubble',
  BorderWidthBubbleUser: '--webchat__border-width--bubble-user',
  BorderWidthTranscriptActivityVisualKeyboardIndicator:
    '--webchat__border-width--transcript-activity-visual-keyboard-indicator',
  BorderRadiusTranscriptTerminator: '--webchat__border-radius--transcript-terminator',
  BorderWidthTranscriptVisualKeyboardIndicator: '--webchat__border-width--transcript-visual-keyboard-indicator',
  ColorAccent: '--webchat__color--accent',
  ColorBubble: '--webchat__color--bubble',
  ColorBubbleUser: '--webchat__color--bubble-user',
  ColorCardPushButton: '--webchat__color--card-push-button',
  ColorCodeBlock: '--webchat__color--code-block',
  ColorConnectivityFailed: '--webchat__color--connectivity-failed',
  ColorSubtle: '--webchat__color--subtle',
  ColorTimestamp: '--webchat__color--timestamp',
  ColorTranscriptActivityVisualKeyboardIndicator: '--webchat__color--transcript-activity-visual-keyboard-indicator',
  ColorTranscriptOverlayButton: '--webchat__color--transcript-overlay-button',
  ColorTranscriptOverlayButtonDisabled: '--webchat__color--transcript-overlay-button-disabled',
  ColorTranscriptOverlayButtonFocus: '--webchat__color--transcript-overlay-button-focus',
  ColorTranscriptOverlayButtonHover: '--webchat__color--transcript-overlay-button-hover',
  ColorTranscriptTerminator: '--webchat__color--transcript-terminator',
  ColorTranscriptVisualKeyboardIndicator: '--webchat__color--transcript-visual-keyboard-indicator',
  FontPrimary: '--webchat__font--primary',
  FontMonospace: '--webchat__font--monospace',
  FontSizeSmall: '--webchat__font-size--small',
  FontSizeTranscriptTerminator: '--webchat__font-size--transcript-terminator',
  IconURLExternalLink: '--webchat__icon-url--external-link',
  MaxHeightImageBubble: '--webchat__max-height--image-bubble',
  MaxHeightSendBoxAttachmentBar: '--webchat__max-height--send-box-attachment-bar',
  MaxWidthAttachmentBubble: '--webchat__max-width--attachment-bubble',
  MaxWidthMessageBubble: '--webchat__max-width--message-bubble',
  MinHeightBubble: '--webchat__min-height--bubble',
  MinHeightImageBubble: '--webchat__min-height--image-bubble',
  MinWidthAttachmentBubble: '--webchat__min-width--attachment-bubble',
  MinWidthMessageBubble: '--webchat__min-width--message-bubble',
  PaddingConnectivityIcon: '--webchat__padding--connectivity-icon',
  PaddingRegular: '--webchat__padding--regular',
  SizeAvatar: '--webchat__size--avatar',
  SizeBubbleNub: '--webchat__size--bubble-nub',
  SizeBubbleNubUser: '--webchat__size--bubble-nub-user',
  SpaceBubbleNub: '--webchat__space--bubble-nub',
  SpaceBubbleNubUser: '--webchat__space--bubble-nub-user',
  TransitionDuration: '--webchat__transition-duration',
  TransitionEasing: '--webchat__transition-easing',
  WordBreakMessageActivity: '--webchat__word-break--message-activity'
}) satisfies Readonly<Record<string, `--webchat__${string}`>>;

export default CustomPropertyNames;
